$(document).ready(function () {
  setInterval(updateForecastTimer, 1000);

  function updateForecastTimer() {
    $(".forecasts-grid-item__middle__timer").each(function () {
      forecastTimer(this);
    });

    $(".super-forecasts-table-item-timer").each(function () {
      forecastTimer(this);
    });
  }

  function forecastTimer(item) {
    let endTime = new Date($(item).data("date"));

    let pageOpenTime = new Date().toLocaleString("en-US", {
      timeZone: "Europe/Moscow",
    });
    pageOpenTime = new Date(pageOpenTime);

    let delta = Math.floor((endTime - pageOpenTime) / 1000);

    if (delta < 60) {
      $(item).html("<b>Live или завершен</b>");
      return;
    }

    let days = Math.floor(delta / 86400);
    delta -= days * 86400;

    let hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    let minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    let seconds = delta % 60;

    let timerStr = "";

    if (days > 0) {
      timerStr = timerStr + `${days}д `;
    }
    if (hours > 0 || days > 0) {
      timerStr = timerStr + `${hours}ч `;
    }
    timerStr = timerStr + `${minutes}мин`;
    if (days == 0) {
      timerStr = timerStr + ` ${seconds}сек `;
    }

    $(item).find("b").html(timerStr);
  }

  function createCountDown(date, timer, emptyText) {
    const cardDays = timer.find(".js-card-days");
    const cardHours = timer.find(".js-card-hours");
    const cardMinutes = timer.find(".js-card-minutes");

    // Set the date we're counting down to
    let countDownDate = new Date(date).getTime();

    // Get today's date and time
    let now = new Date().getTime();

    // Find the distance between now and the count down date
    let distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));

    if (days > 99) {
    } else {
    }

    let hours;
    if (cardDays.length) {
      hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    } else {
      hours =
        Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) +
        days * 24;
    }
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    if (cardDays.length) {
      const daysString = days.toString();

      if (daysString == "0") {
        cardDays.find(".card-timer__number:first-child").text(0);
        cardDays.find("card-timer__number:last-child").text(0);
      } else {
        if (daysString.length == 1) {
          cardDays.find(".card-timer__number:first-child").text(0);
          cardDays.find(".card-timer__number:last-child").text(daysString);
        } else if (daysString.length == 2) {
          cardDays.find(".card-timer__number:first-child").text(daysString[0]);
          cardDays.find(".card-timer__number:last-child").text(daysString[1]);
        } else {
          cardDays.find(".card-timer__number:first-child").text(daysString[0]);
          cardDays.find(".card-timer__number:nth-child(1)").text(daysString[1]);
          cardDays.find(".card-timer__number:last-child").text(daysString[2]);
        }
      }
    }

    if (cardHours.length) {
      const hoursString = hours.toString();

      if (hoursString == "0") {
        cardHours.find(".card-timer__number:first-child").text(0);
        cardHours.find(".card-timer__number:last-child").text(0);
      } else {
        if (hoursString.length == 1) {
          cardHours.find(".card-timer__number:first-child").text(0);
          cardHours.find(".card-timer__number:last-child").text(hoursString);
        } else {
          cardHours
            .find(".card-timer__number:first-child")
            .text(hoursString[0]);
          cardHours.find(".card-timer__number:last-child").text(hoursString[1]);
        }
      }
    }

    if (cardMinutes.length) {
      const minutesString = minutes.toString();

      if (minutesString == "0") {
        cardMinutes.find(".card-timer__number:first-child").text(0);
        cardMinutes.find(".card-timer__number:last-child").text(0);
      } else {
        if (minutesString.length == 1) {
          cardMinutes.find(".card-timer__number:first-child").text(0);
          cardMinutes
            .find(".card-timer__number:last-child")
            .text(minutesString);
        } else {
          cardMinutes
            .find(".card-timer__number:first-child")
            .text(minutesString[0]);
          cardMinutes
            .find(".card-timer__number:last-child")
            .text(minutesString[1]);
        }
      }
    }

    // If the count down is finished, write some text
    if (distance < 0) {
      timer.html(
        '<span class="card-timer__placeholder">' + emptyText + "</span>"
      );
    }
  }

  function forecastsTimerInit() {
    // Таймер Прогнозы
    $(".forecasts__item").each(function () {
      const cardTimer = $(this).find(".card-timer");
      if (cardTimer.length) {
        const cardDate = cardTimer.data("timer-until");

        createCountDown(cardDate, cardTimer, "Матч окончен");
      }
    });
  }

  function bonusesrTimerInit() {
    // Таймер Бонусы
    $(".bonus__item").each(function () {
      const cardTimer = $(this).find(".card-timer");
      if (cardTimer.length) {
        const cardDate = cardTimer.data("timer-until");
        if (cardDate === "Бессрочно" || cardDate === "Бессрочная") {
          cardTimer.html(
            '<span class="card-timer__placeholder card-timer__placeholder--infinity">Бессрочный</span>'
          );
        } else {
          const [cardDay, cardMonth, cardYear] = cardDate.split(".");

          // Set the date we're counting down to
          let countDownDate = new Date(
            cardYear + "/" + cardMonth + "/" + cardDay
          ).getTime();

          createCountDown(
            countDownDate,
            cardTimer,
            "Действие бонуса закончилось"
          );
        }
      }
    });
  }

  $(document).on("as_complete", document, function (e, d) {
    tippy("[data-tippy-content]");

    bonusesrTimerInit();

    forecastsTimerInit();
  });

  $(document).on("mse2_load", function (e, data) {
    bonusesrTimerInit();
  });

  $(document).on("pdopage_load", function (e, config, response) {
    forecastsTimerInit();
  });

  //Обновляем таймер каждую минуту
  setInterval(() => {
    bonusesrTimerInit();
    forecastsTimerInit();
  }, 60000);
});
